import { useState } from 'react';
import { Cloud, Fingerprint, Radar, ScanSearch } from 'lucide-react';

const colors = {
  navy: '#092952',
  blue: '#0B3B78',
  muted: '#526377',
  border: '#DCE3EC',
};

const toolGroups = [
  { icon: Radar, title: 'Detection & response', tools: ['Microsoft Sentinel', 'Microsoft Defender XDR', 'Splunk', 'Elastic Security'] },
  { icon: Fingerprint, title: 'Identity & access', tools: ['Microsoft Entra ID', 'Okta', 'CyberArk', 'Duo Security'] },
  { icon: Cloud, title: 'Cloud protection', tools: ['AWS Security Hub', 'Microsoft Defender for Cloud', 'Google Security Command Center', 'Cloud-native logging'] },
  { icon: ScanSearch, title: 'Assessment & testing', tools: ['Tenable', 'Qualys', 'Burp Suite', 'OWASP ZAP'] },
];

function SectionHeading({ title, text, centered = false }) {
  return <div className={centered ? 'cyber-centered mx-auto max-w-6xl text-center' : 'max-w-4xl'}>
    <h2 className="text-[32px] font-semibold leading-[48px]" style={{ color: '#183762' }}>{title}</h2>
    {text && <p className="mt-5 text-base font-normal leading-[27px]" style={{ color: '#212121' }}>{text}</p>}
  </div>;
}

export default function CybersecurityTechnologyStacks() {
  const [activeTools, setActiveTools] = useState(0);
  const toolGroup = toolGroups[activeTools];
  const ToolIcon = toolGroup.icon;
  return (<section className="border-y px-5 py-16 sm:px-6 lg:px-10 lg:py-12" style={{ borderColor: colors.border }}>
      <div className="mx-auto max-w-7xl"><SectionHeading title="Security platforms and tools that fit the environment" text="The right stack depends on your systems, existing investments and operational needs. These are representative platforms we can use across assessment, identity, cloud and response." centered />
        <div className="mt-10 grid overflow-hidden md:grid-cols-[minmax(220px,0.85fr)_1.15fr] lg:mt-14">
          <nav className="overflow-hidden px-5 py-5 sm:px-8 sm:py-7 lg:px-10 lg:py-8" style={{ background: colors.navy }} aria-label="Security technology categories">
            <div className="max-h-[330px] overflow-y-auto pr-3 sm:pr-4" style={{ scrollbarColor: '#FFFFFF #48688D', scrollbarWidth: 'thin' }}>
              {toolGroups.map((group, index) => <button key={group.title} type="button" onClick={() => setActiveTools(index)} aria-pressed={activeTools === index} className="flex w-full items-center gap-3 border-b py-4 text-left sm:gap-4 sm:py-5" style={{ borderColor: 'rgba(255,255,255,0.2)', color: activeTools === index ? '#FFFFFF' : 'rgba(255,255,255,0.65)' }}><span className="shrink-0 text-sm font-semibold sm:text-base">{String(index + 1).padStart(2, '0')}.</span><span className="text-sm font-semibold sm:text-base lg:text-lg">{group.title}</span></button>)}
            </div>
          </nav>
          <div className="flex items-center bg-[#f5f5f5] p-5 sm:p-7 lg:p-8" aria-live="polite" aria-label={toolGroup.title}>
            <div className="mx-auto grid w-full max-w-xl gap-3">
              {toolGroup.tools.map((tool) => <div key={tool} className="flex min-h-[54px] items-center gap-3 border bg-white px-4 py-3 sm:gap-4 sm:px-5" style={{ borderColor: '#D8DEE5' }}><ToolIcon size={25} strokeWidth={1.5} className="shrink-0" style={{ color: colors.blue }} aria-hidden="true" /><span className="text-sm font-medium leading-tight sm:text-base" style={{ color: colors.navy }}>{tool}</span></div>)}
            </div>
          </div>
        </div>
      </div>
    </section>);
}
